import { useWebsite } from 'hooks/website/useWebsite';

import s from './PlayfulPreviewImage.module.css';

export const PlayfulPreviewImage = () => {
  const {
    home: {
      hero: { image: heroImageSrc },
    },
  } = useWebsite();

  return (
    <div
      role="img"
      title="Playful Image Preview"
      className={s.image}
      style={{
        backgroundImage: `url(${heroImageSrc})`,
      }}
    />
  );
};
